import { CAMINHOS_MARCA } from '../lib/marca';
// Símbolo "S" da marca — vetor oficial (Manual v1.0/2026 §03), o mesmo do site.
// currentColor: a cor vem do token do design system, não do arquivo.
// Proporção 738x502 — dimensione pela altura, largura em auto.
export default function Marca({ className = 'h-7 w-auto' }: { className?: string }) {
  return (
    <svg viewBox="0 0 738 502" fill="currentColor" className={className} aria-hidden="true">
      <path d={CAMINHOS_MARCA[0]} />
      <path d={CAMINHOS_MARCA[1]} />
    </svg>
  );
}
